/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { FileText } from 'react-feather';
import { Box } from '../components';
import { CloseButtonZero } from './modal/Elements';
import { theme } from '../theme';

type ListItemProps = {
  listItemText: string;
  onClick: () => void;
};
const UploadedFileItem: React.FC<ListItemProps> = (props) => {
  return (
    <Box height="150px" width="150px" flexDirection="column" bg={theme.colors.paleGrey} mb={2}>
      <div style={{ alignItems: 'center', justifyContent: 'center', marginTop: '15px', textAlign: 'center' }}>
        <FileText size={80} color="#9EA1A5" />
      </div>
      <div style={{ marginTop: '20px', marginLeft: '2px', textAlign: 'center' }}>
        {props.listItemText.substr(0, 40)}
        {props.listItemText.length >= 40 ? '...' : ''}
      </div>
      <div style={{ position: 'absolute', right: 0, top: 0, marginLeft: '30px', backgroundColor: 'red' }}>
        <CloseButtonZero onClick={props.onClick} />
      </div>
    </Box>
  );
};

export default UploadedFileItem;



// WEBPACK FOOTER //
// ./src/components/UploadedFileItem.tsx